import React, { useEffect, useRef, useState } from "react";
import services from "../../../api/services";
import dayjs from "dayjs";
import {
	checkItemAvailabilityChangeBasketMode,
	getApplication,
	getRestaurant,
	getServiceTypes,
	getTotalPrice,
	updateBasket,
} from "../../../utils/commons";
import { useDispatch, useSelector } from "react-redux";
import {
	setMode,
	setOrder,
	setOrderInfo,
	setOrderRequestedTime,
	updateItems,
} from "../../../redux/reducers/basket";
import "dayjs/locale/fr";
import ReactGoogleAutocomplete, {
	usePlacesWidget,
} from "react-google-autocomplete";
import { Modal } from "react-bootstrap";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import _ from "lodash";
import { NavLink } from "react-router-dom";
import AlertBasketUpdate from "../../layouts/AlertBasketUpdate";

dayjs.locale("fr");
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);

const application = getApplication();
const serviceTypes = getServiceTypes();

const Content = ({ restaurant }) => {
	const basket = useSelector((state) => state.basket);
	const dispatch = useDispatch();

	// const [basket, setBasket] = useState(getBasket());
	const [basketTotal, setBasketTotal] = useState(getTotalPrice(basket));
	const [timeSlots, setTimeSlots] = useState([]);
	const [requestedTime, setRequestedTime] = useState(null);
	const [comment, setComment] = useState("");
	const [promoCode, setPromoCode] = useState("");
	const [promoInfo, setPromoInfo] = useState({
		discountAmount: 0,
		promoCode: "",
	});
	const [info, setInfo] = useState(basket.info || {});
	const [address, setAddress] = useState({});
	const [formErrors, setFormErrors] = useState({});
	const [showAlert, setShowAlert] = useState(false);
	const [newMode, setNewMode] = useState(basket.mode);
	const [outOfPerimeter, setOutOfPerimeter] = useState(false);
	const [refreshingCart, setRefreshingCart] = useState(true);
	const [isClosed, setIsClosed] = useState(false);
	const inPayment = useRef(false);
	const maxPreparationTime = useRef(0);

	const center = {
		lat: parseFloat(restaurant.latitude),
		lng: parseFloat(restaurant.longitude),
	};
	// Create a bounding box with sides ~10km away from the center point
	const defaultBounds = {
		north: center.lat + 0.3,
		south: center.lat - 0.3,
		east: center.lng + 0.3,
		west: center.lng - 0.3,
	};

	const { ref, autocompleteRef } = usePlacesWidget({
		apiKey: process.env.REACT_APP_GOOGLE,
		onPlaceSelected: (place) => {
			//autocompleteRef.current.setValue(place?.formatted_address);
			const lAddress = {
				location: {
					coords: {
						latitude: place.geometry.location.lat(),
						longitude: place.geometry.location.lng(),
					},
				},
				address: place.formatted_address,
			};
			setAddress(lAddress);

			checkAddress(lAddress);
		},
		options: {
			componentRestrictions: { country: "fr" },
			types: ["geocode"],
			bounds: defaultBounds,
			strictBounds: true,
		},
	});

	const getDistanceFromLatLonInKm = (lat1, lon1, lat2, lon2) => {
		if (!lat1 || !lat2 || !lon1 || !lon2) return 99999;
		var R = 6371; // Radius of the earth in km
		var dLat = deg2rad(lat2 - lat1); // deg2rad below
		var dLon = deg2rad(lon2 - lon1);
		var a =
			Math.sin(dLat / 2) * Math.sin(dLat / 2) +
			Math.cos(deg2rad(lat1)) *
				Math.cos(deg2rad(lat2)) *
				Math.sin(dLon / 2) *
				Math.sin(dLon / 2);
		var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
		var d = R * c; // Distance in km
		return d;
	};
	const deg2rad = (deg) => {
		return deg * (Math.PI / 180);
	};
	const checkAddress = (address) => {
		let restLatitude = restaurant.latitude;
		let restLongitude = restaurant.longitude;
		let distMax = parseFloat(restaurant.perimeterDelivery);
		let dist = getDistanceFromLatLonInKm(
			address.location.coords.latitude,
			address.location.coords.longitude,
			restLatitude,
			restLongitude
		);

		if (dist < distMax) {
			setOutOfPerimeter(false);
		} else {
			setOutOfPerimeter(true);
		}
	};

	useEffect(() => {
		if (!basket.mode || !serviceTypes.includes(basket.mode)) {
			dispatch(setMode({ mode: serviceTypes[0] }));
		}
		let preparationTime = 0;
		basket.items.forEach((item) => {
			if (item.selectedItems) {
				for (let sItem of item.selectedItems) {
					if (preparationTime < sItem.preparationTime) {
						preparationTime = sItem.preparationTime;
					}
				}
			}
			if (item.preparationTime && item.preparationTime > preparationTime) {
				preparationTime = item.preparationTime;
			}
		});

		maxPreparationTime.current = preparationTime;

		getTimeSlots(maxPreparationTime.current, basket.mode);
		// const timeSlots = getTimeSlots(preparationTime);
		// if (timeSlots.length === 0) {
		// 	setIsClosed(true);
		// } else {
		// 	setIsClosed(false);
		// }

		// setTimeSlots(getTimeSlots(preparationTime));
	}, []);

	useEffect(() => {
		setBasketTotal(getTotalPrice(basket, promoInfo.discountAmount));
	}, [basket.updatedAt, promoInfo.discountAmount]);

	const [validateBasket, setValidateBasket] = useState(false);

	const checkErrors = () => {
		const errors = {};
		if (!info.lastName) {
			errors.lastName = "";
		}
		if (!info.firstName) {
			errors.firstName = "";
		}
		if ((!address || !address.location) && basket.mode === "delivery") {
			errors.address = "L'adresse de livraison est obligatoire";
		}
		if (!info.telephone) {
			errors.telephone = "";
		} else if (
			!/^(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}$/gm.test(info.telephone)
		) {
			errors.telephone = "Téléphone invalide";
		}

		if (!info.email) {
			errors.email = "";
		} else if (
			!/^[A-Za-z0-9_!#$%&'*+\/=?`{|}~^.-]+@[A-Za-z0-9.-]+$/gm.test(info.email)
		) {
			errors.email = "Email invalide";
		}

		setFormErrors(errors);
		return errors;
	};
	const validateOrder = () => {
		const formErrors = checkErrors();
		if (Object.keys(formErrors).length) {
			return;
		} else if (inPayment.current) {
			return;
		}
		setValidateBasket(true);

		const now = dayjs().add(maxPreparationTime.current, "minute");
		let requestedDate = dayjs(requestedTime * 1000);

		if (now.isAfter(requestedDate)) {
			const timeSlots = getTimeSlots(maxPreparationTime.current);
			if (timeSlots.length) {
				requestedDate = dayjs(timeSlots[0].value * 1000);
			} else {
				//popup erreur
			}
		}

		inPayment.current = true;
		services.saveOrder(
			{
				...basket,
				...basket.items,
				totalPrice: getTotalPrice(basket),
				requestedTime: requestedDate.format("YYYY-MM-DD HH:mm:ss"),
				orderTime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
				comment,
				restaurantId: restaurant.restaurantId,
				appId: application.appId,
				//payment: "CASH",
				user: {},
				mode: basket.mode,
				info: { ...info, address },
				deliveryAddress:
					basket.mode === "delivery"
						? { ...address, complementAddress: info.complementAddress }
						: null,
				discountAmount: promoInfo.discountAmount,
				promocode: promoCode,
			},
			(res) => {
				//				setValidateBasket(false);
				dispatch(setOrderRequestedTime(requestedTime));
				dispatch(setOrderInfo({ ...info, address }));
				dispatch(setOrder(res.order));
				makePayment(res.order.orderId);
			},
			(err) => {
				inPayment.current = false;
				setValidateBasket(false);

				console.warn("err in posting the order", err);
			}
		);
	};

	const makePayment = (orderId) => {
		let paymentData = {
			orderId,
			returnUrl: window.location.origin + "/check-paiement?orderId=" + orderId,
		};

		services.payinWithMangopay(
			paymentData,
			(res) => {
				console.warn("payinWithMangopay ok", res.paymentResult.RedirectURL);

				window.location = res.paymentResult.RedirectURL;
				inPayment.current = false;
			},
			(err) => {
				console.warn("payinWithMangopay err", err);
			}
		);
	};

	const checkPromo = () => {
		setPromoInfo({ ...promoInfo, checking: true });

		services.checkPromo(
			{
				promocode: promoCode,
				restaurantId: restaurant.restaurantId,
				items: basket.items,
				mode: basket.mode,
				orderAmount: parseFloat(basketTotal).toFixed(2),
			},
			(res) => {
				// console.log('result', res);

				if (res.success) {
					setPromoInfo({
						promoValide: true,
						promoMessage: res.message,
						discountAmount: parseFloat(res.discountAmount),
						promoValue: res.promo.value,
						typePromo: res.promo.typePromo,
						checking: false,
					});
				} else {
					setPromoInfo({
						promoValide: false,
						promoMessage: res.message,
						discountAmount: 0,
						promocode: "",
						checking: false,
					});
					setPromoCode("");
				}
			},
			(err) => {}
		);
	};

	const getHoursAndMinInMinutes = (hours, min) => {
		return hours * 60 + min;
	};

	const getTimeSlots = (maxPreparationTime, mode) => {
		let preparationTime = maxPreparationTime;
		if (mode == "delivery") {
			preparationTime = preparationTime + 15;
		}

		services.isRestaurantOpen(
			{
				restaurantId: restaurant.restaurantId,
				requestedTime: dayjs()
					.add(preparationTime, "minute")
					.format("YYYY-MM-DD HH:mm:ss"),
				allDay: 1,
				preparationTime: preparationTime,
			},
			(res) => {
				setTimeSlots(res.timeSlots);
				setIsClosed(!res.isOpen);
				if (res.timeSlots.length > 0) {
					setRequestedTime(res.timeSlots[0].value);
				}

				setTimeout(() => setRefreshingCart(false), 500);
			}
		);
	};

	const selectMode = (mode, validate = false) => {
		if (!validate && checkItemAvailabilityChangeBasketMode(mode)) {
			setNewMode(mode);
			setShowAlert(true);
		} else {
			setRefreshingCart(true);

			let previousMode = basket.mode;

			dispatch(
				setMode({
					mode,
					deliveryFees: mode === "delivery" ? restaurant.deliveryFees : 0,
				})
			);

			updateBasket(mode);

			if (
				previousMode != mode &&
				(mode == "delivery" || previousMode == "delivery")
			) {
				getTimeSlots(maxPreparationTime.current, mode);
			} else {
				setTimeout(() => setRefreshingCart(false), 500);
			}
		}
	};

	// const updatePrice = (mode) => {
	// 	const items = basket.items.map((item) => {
	// 		let nItem = { ...item };
	// 		let itemPrice = null;
	// 		if (mode === "delivery" && item.priceDelivery) {
	// 			itemPrice = item.priceDelivery;
	// 		} else if (mode === "takeAway" && item.priceTakeAway) {
	// 			itemPrice = item.priceTakeAway;
	// 		} else {
	// 			if (item.menuId) {
	// 				itemPrice = item.menuPrice;
	// 			} else {
	// 				itemPrice = item.productPrice;
	// 			}
	// 		}

	// 		if (item.menuId) {
	// 			nItem.basePrice = getMenuTotalPrice(
	// 				itemPrice,
	// 				_.cloneDeep(item.content)
	// 			);
	// 		} else {
	// 			nItem.basePrice = itemPrice;
	// 		}

	// 		nItem.price = parseFloat(nItem.basePrice) - (nItem.discountAmount || 0);

	// 		return nItem;
	// 	});

	// 	dispatch(
	// 		updateItems({
	// 			items,
	// 		})
	// 	);
	// 	// setBasketTotal(getTotalPrice({items, mode}));
	// };

	return (
		<section className="section">
			<div className="container">
				{isClosed && (
					<div className="alert alert-warning" role="alert">
						<h4 className="alert-heading">Restaurant fermé</h4>
						<p>
							Votre commande ne peut pas être finalisée car le restaurant est
							fermé !
						</p>
					</div>
				)}
				<form method="post">
					<div className="row">
						<div className="col-xl-7">
							<div className="cart-checkout-div">
								<div className="row">
									<div className="col-sm-12 col-12">
										<h4>Choisissez votre mode de consommation : </h4>
									</div>
									<div className="col-sm-12 col-12 justify-content-around">
										<div className="row services-button-container">
											{serviceTypes.includes("takeAway") && (
												<div className="form-group">
													<button
														type="button"
														className={
															"btn-custom btn-service shadow-none btn-sm " +
															(basket.mode != "takeAway" ? "light" : "")
														}
														onClick={() => {
															setInfo({
																...info,
																address: {},
																complementAddress: {},
															});
															selectMode("takeAway");
														}}
														disabled={isClosed}
													>
														A emporter
													</button>
												</div>
											)}
											{serviceTypes.includes("onSite") && (
												<div className="form-group">
													<button
														type="button"
														className={
															"btn-custom btn-service shadow-none btn-sm " +
															(basket.mode != "onSite" ? "light" : "")
														}
														onClick={() => {
															setInfo({ ...info, address: {} });
															selectMode("onSite");
														}}
														disabled={isClosed}
													>
														Sur place
													</button>
												</div>
											)}
											{serviceTypes.includes("delivery") && (
												<div className="form-group">
													<button
														disabled={
															!restaurant.deliveryEnabled ||
															basketTotal -
																(basket.mode == "delivery"
																	? restaurant.deliveryFees
																	: 0) <
																parseFloat(restaurant.minAmountDelivery) ||
															isClosed
														}
														type="button"
														className={
															"btn-custom btn-service shadow-none btn-sm " +
															(basket.mode != "delivery" ? "light" : "")
														}
														onClick={() => selectMode("delivery")}
													>
														En Livraison
													</button>
													{!!restaurant && !restaurant.deliveryEnabled ? (
														<div className=" text-center">
															<span className="fs-14" style={{}}>
																Non disponible
															</span>
														</div>
													) : !!restaurant &&
													  basketTotal -
															(basket.mode == "delivery"
																? restaurant.deliveryFees
																: 0) <
															parseFloat(restaurant.minAmountDelivery) ? (
														<div className=" text-center">
															<span className="fs-14" style={{}}>
																Min. {restaurant.minAmountDelivery} €
															</span>
														</div>
													) : null}
												</div>
											)}
										</div>
									</div>
								</div>
								<div className="row form-group">
									<div className="col-sm-12 col-12">
										<h4>
											{basket.mode === "delivery"
												? "Je souhaite être livré :"
												: "Je viens récupérer ma commande :"}
										</h4>
									</div>
									<div className="col-sm-12 col-12 justify-content-around">
										<div className="row">
											<div className="col-sm-6 col-12">
												<select
													disabled={timeSlots.length === 0}
													className="form-control"
													value={requestedTime || ""}
													onChange={({ target }) => {
														console.log("coucou", target.value);
														setRequestedTime(target.value);
													}}
												>
													{timeSlots.map((slot, ind) => {
														// <div className="col-sm-4 col-12" key={ind}>
														// 	{slot}
														// </div>
														return (
															<option value={slot.value} key={ind}>
																entre {slot.label} et {slot.nextTime}
															</option>
														);
													})}
												</select>
											</div>
										</div>
									</div>
								</div>
							</div>
							{/* Login */}
							{/* <Accordion defaultActiveKey="0"> */}
							{/*<div className="ct-notice">
									<p>
										Déjà client ?
										<Accordion.Toggle
											as={NavLink}
											variant="link"
											eventKey="0"
											className="p-0"
										>
											Identifiez-vous
										</Accordion.Toggle>
									</p>
								</div>
								<Accordion.Collapse eventKey="0">
									<div className="ct-notice-content d-block">
										<div className="row">
											<div className="col-xl-6 form-group">
												<label>Email</label>
												<input
													type="text"
													className="form-control"
													name="login-email"
													placeholder="Email"
												/>
											</div>
											<div className="col-xl-6 form-group">
												<label>Mot de passe</label>
												<input
													type="password"
													className="form-control"
													name="login-pass"
													placeholder="Mot de passe"
												/>
											</div>
											<div className="col-12 form-group">
												<div className="custom-control custom-checkbox">
													<input
														type="checkbox"
														className="custom-control-input"
														id="rememberMe"
													/>
													<label
														className="custom-control-label"
														htmlFor="rememberMe"
													>
														Se souvenir de moi
													</label>
												</div>
											</div>
											<div className="col-12">
												<button
													type="submit"
													className="btn-custom shadow-none btn-sm"
													name="button"
												>
													Se connecter
												</button>
											</div>
										</div>
									</div>
								</Accordion.Collapse>
								{/* Coupon Code */}
							{/* <div className="ct-notice">
									<p>
										Do you have a coupon code?
										<Accordion.Toggle
											as={NavLink}
											variant="link"
											eventKey="1"
											className="p-0"
										>
											Click here to apply
										</Accordion.Toggle>
									</p>
								</div> */}
							{/* <Accordion.Collapse eventKey="1">
									<div className="ct-notice-content d-block">
										<p>If you have a coupon code, apply it below</p>
										<div className="input-group">
											<input
												type="text"
												className="form-control"
												placeholder="Coupon Code"
											/>
											<div className="input-group-append">
												<button
													className="btn-custom shadow-none"
													type="button"
												>
													Apply Code
												</button>
											</div>
										</div>
									</div>
								</Accordion.Collapse> */}
							{/* </Accordion> */}
							{/* Buyer Info */}

							<div className="cart-checkout-div mb-0">
								<h4>Informations</h4>
								<div className="row">
									<div className="form-group col-xl-6">
										<label>
											Prénom <span className="text-danger">*</span>
										</label>
										<input
											type="text"
											placeholder="Prénom"
											name="fname"
											className={
												"form-control " +
												(formErrors["firstName"] !== undefined
													? "border-danger"
													: "")
											}
											required
											value={info.firstName || ""}
											onChange={({ target }) => {
												setInfo({ ...info, firstName: target.value });
												console.log({ info });
											}}
											disabled={isClosed}
										/>
									</div>
									<div className="form-group col-xl-6">
										<label>
											Nom <span className="text-danger">*</span>
										</label>
										<input
											type="text"
											placeholder="Nom"
											name="lname"
											className={
												"form-control " +
												(formErrors["lastName"] !== undefined
													? "border-danger"
													: "")
											}
											required
											value={info.lastName || ""}
											onChange={({ target }) => {
												setInfo({ ...info, lastName: target.value });
											}}
											disabled={isClosed}
										/>
									</div>
									{/* <div className='form-group col-xl-12'>
									<label>Company Name</label>
									<input type='text' placeholder='Company Name (Optional)' name='cname' className='form-control' />
								</div> */}

									{basket.mode === "delivery" && (
										<>
											<div className="form-group col-xl-12">
												<label>
													Adresse <span className="text-danger">*</span>
												</label>

												<ReactGoogleAutocomplete
													name="addr-1"
													apiKey={process.env.REACT_APP_GOOGLE}
													onPlaceSelected={(place) => {
														//autocompleteRef.current.setValue(place?.formatted_address);
														const lAddress = {
															location: {
																coords: {
																	latitude: place.geometry.location.lat(),
																	longitude: place.geometry.location.lng(),
																},
															},
															address: place.formatted_address,
														};
														setAddress(lAddress);

														checkAddress(lAddress);
													}}
													className={
														"form-control " +
														(formErrors["address"] !== undefined
															? "border-danger"
															: "")
													}
													onChange={({ target }) => {
														setAddress({ address: target.value });
													}}
													required
													value={address.address ? address.address : ""}
													options={{
														componentRestrictions: { country: "fr" },
														types: ["geocode"],
														bounds: defaultBounds,
														strictBounds: true,
													}}
													disabled={isClosed}
												/>
												{/* <input
												type="text"
												placeholder="Adresse"
												name="addr-1"
												className={
													"form-control " +
													(formErrors["address"] !== undefined
														? "border-danger"
														: "")
												}
												required
												value={address.address ? address.address : ""}
												onChange={({ target }) => {
													setAddress({ address: target.value });
												}}
												ref={ref}
											/> */}
												{formErrors["address"] && (
													<span className="text-danger font-weight-bold">
														{formErrors["address"]}
													</span>
												)}
												{outOfPerimeter && (
													<span className="text-danger font-weight-bold">
														Désolé, l'adresse est en dehors du périmètre de
														livraison de
														{" " + Math.round(restaurant.perimeterDelivery)} km
													</span>
												)}
											</div>
											<div className="form-group col-xl-12">
												<label>Complément Adresse</label>
												<input
													type="text"
													placeholder="Etage, Bat., ..."
													name="cptAddr"
													className={
														"form-control " +
														(formErrors["complementAddress"] !== undefined
															? "border-danger"
															: "")
													}
													required
													value={info.complementAddress || ""}
													onChange={({ target }) => {
														setInfo({
															...info,
															complementAddress: target.value,
														});
													}}
													disabled={isClosed}
												/>
											</div>
										</>
									)}
									{/* <div className='form-group col-xl-6'>
									<label>Street Address 2</label>
									<input
										type='text'
										placeholder='Street Address Two (Optional)'
										name='addr-1'
										className='form-control'
									/>
								</div> */}
									{/* <div className="form-group col-xl-6">
									<label>
										Code Postal <span className="text-danger">*</span>
									</label>
									<input
										type="text"
										placeholder="Code Postal"
										name="town"
										className="form-control"
										required
									/>
								</div>
								<div className="form-group col-xl-6">
									<label>
										Ville <span className="text-danger">*</span>
									</label>
									<input
										type="text"
										placeholder="Ville"
										name="town"
										className="form-control"
										required
									/>
								</div> */}
									<div className="form-group col-xl-6">
										<label>
											Téléphone <span className="text-danger">*</span>
										</label>
										<input
											type="text"
											placeholder="Téléphone"
											name="telephone"
											className={
												"form-control " +
												(formErrors["telephone"] !== undefined
													? "border-danger"
													: "")
											}
											required
											value={info.telephone || ""}
											onChange={({ target }) => {
												setInfo({ ...info, telephone: target.value });
											}}
											disabled={isClosed}
										/>
										{formErrors["telephone"] && (
											<span className="text-danger font-weight-bold">
												{formErrors["telephone"]}
											</span>
										)}
									</div>
									<div className="form-group col-xl-6">
										<label>
											Email <span className="text-danger">*</span>
										</label>
										<input
											type="email"
											placeholder="Email"
											name="email"
											className={
												"form-control " +
												(formErrors["email"] !== undefined
													? "border-danger"
													: "")
											}
											required
											value={info.email || ""}
											onChange={({ target }) => {
												setInfo({ ...info, email: target.value });
											}}
											disabled={isClosed}
										/>
										{formErrors["email"] && (
											<span className="text-danger font-weight-bold">
												{formErrors["email"]}
											</span>
										)}
									</div>
									<div className="form-group col-xl-12 mb-0">
										<label>Commentaire</label>
										<textarea
											name="name"
											rows={5}
											className="form-control"
											placeholder="Commentaire (Optionel)"
											onChange={({ target }) => setComment(target.value)}
											disabled={isClosed}
										/>
									</div>
								</div>
								{/* /Buyer Info */}
							</div>
						</div>
						<div className="col-xl-5 checkout-billing">
							{/* Order Details Start */}
							<table className="ct-responsive-table">
								<thead>
									<tr>
										<th>Produit</th>
										<th>Quantité</th>
										<th>Total</th>
									</tr>
								</thead>
								<tbody>
									{basket.items.map((item, i) => (
										<tr key={i}>
											<td data-title="Produit" className="noBefore">
												<div className="cart-product-wrapper">
													<div className="cart-product-body">
														<h6>
															{" "}
															{/* <Link to='/menu-item-v1/1'> */}
															{item.name}
															{/* </Link>{" "} */}
														</h6>
														{item.selectedItems ? (
															item.selectedItems.map((sItem, i) => (
																<React.Fragment key={i}>
																	<p>{sItem.name}</p>
																	{sItem.selectedOptions
																		? sItem.selectedOptions.map((sOpt, iO) => (
																				<p key={iO}>
																					&nbsp;&nbsp;&nbsp;
																					{sOpt.name}
																					{sOpt.quantity > 1 &&
																						" x" + sOpt.quantity}
																				</p>
																		  ))
																		: null}
																</React.Fragment>
															))
														) : item.selectedOptions ? (
															item.selectedOptions.map((sOpt, iO) => (
																<p key={iO}>
																	&nbsp;&nbsp;&nbsp;
																	{sOpt.name}
																	{sOpt.quantity > 1 && " x" + sOpt.quantity}
																</p>
															))
														) : (
															<span></span>
														)}
													</div>
												</div>
											</td>
											<td data-title="Quantité">x{item.quantity || 1}</td>
											<td data-title="Total">
												{" "}
												<strong>
													{(
														parseFloat(item.price) * (item.quantity || 1)
													).toFixed(2)}{" "}
													€
												</strong>{" "}
											</td>
										</tr>
									))}
									{basket.mode === "delivery" && (
										<tr>
											<td data-title="Frais" className="noBefore">
												<div className="cart-product-wrapper">
													<div className="cart-product-body">
														<h6>Frais de livraison</h6>
													</div>
												</div>
											</td>
											<td></td>
											<td data-title="Frais">
												{" "}
												<strong>
													{parseFloat(basket.deliveryFees).toFixed(2)} €
												</strong>{" "}
											</td>
										</tr>
									)}
									{!!promoInfo.discountAmount &&
										promoInfo.discountAmount > 0 && (
											<tr>
												<td data-title="Remise">
													<div className="cart-product-wrapper">
														<div className="cart-product-body">
															<h6>Remise</h6>
														</div>
													</div>
												</td>
												<td></td>
												<td data-title="Remise">
													{" "}
													<strong>
														-{parseFloat(promoInfo.discountAmount).toFixed(2)} €
													</strong>{" "}
												</td>
											</tr>
										)}
									<tr className="total">
										<td>
											<h6 className="mb-0">Total à Payer</h6>
										</td>
										<td />
										<td>
											{" "}
											<strong>
												{parseFloat(basketTotal).toFixed(2)} €
											</strong>{" "}
										</td>
									</tr>
								</tbody>
							</table>
							{/* <div className='form-group'>
								<label>Card Number</label>
								<input type='text' className='form-control' name='master-number' placeholder='Card Number' />
							</div>
							<div className='form-group'>
								<label>Full Name</label>
								<input type='text' className='form-control' name='master-name' placeholder='Full Name' />
							</div>
							<div className='row'>
								<div className='col-xl-6 form-group'>
									<label>Expiry Date</label>
									<input type='text' className='form-control' name='master-expiry' placeholder='Expiry Date (MM/YY)' />
								</div>
								<div className='col-xl-6 form-group'>
									<label>CVV*</label>
									<input type='number' className='form-control' name='master-cvv' placeholder='CVV' />
								</div>
							</div>
							<p className='small'>
								Your personal data will be used to process your order, support your experience throughout this website, and for other
								purposes described in our{' '}
								<Link className='btn-link' to='#'>
									privacy policy.
								</Link>{' '}
							</p> */}

							{!isClosed &&
								!!application &&
								!!application.promocodeModuleEnabled && (
									<div>
										<div className="ct-notice-content d-block">
											<label>Vous avez un code promo ?</label>
											<div className="input-group">
												<input
													type="text"
													className="form-control"
													placeholder="CODE PROMO"
													value={promoCode}
													onChange={({ target }) => {
														setPromoCode(target.value);
													}}
													disabled={isClosed || promoInfo.checking}
												/>
												<div className="input-group-append">
													<button
														className="btn-custom btn-block btn-promo third"
														type="button"
														disabled={isClosed || promoInfo.checking}
														onClick={() => checkPromo()}
													>
														Appliquer
													</button>
												</div>
											</div>
											{promoInfo.promoValide === false &&
												!!promoInfo.promoMessage && (
													<span className="text-danger font-weight-bold">
														Code promo invalide
													</span>
												)}
										</div>

										{/* <label>Code promo</label> */}

										{/* <div className="form-group row">
										<div class="col-xs-12 col-sm-6" style={{ marginBottom: 5 }}>
											<input
												type="text"
												placeholder="CODE PROMO"
												name="promoCode"
												className="form-control"
												value={promoCode}
												onChange={({ target }) => {
													setPromoCode(target.value);
												}}
												disabled={isClosed || promoInfo.checking}
											/>
										</div>
										<div class="col-xs-12 col-sm-6">
											<button
												type="button"
												className="btn-custom btn-block btn-promo third"
												disabled={isClosed || promoInfo.checking}
												onClick={() => checkPromo()}
											>
												Appliquer
											</button>
										</div>
									</div> */}
									</div>
								)}

							{!isClosed && (
								<>
									<button
										type="button"
										className="btn-custom primary btn-block"
										onClick={() => validateOrder()}
										disabled={
											!basket.mode ||
											outOfPerimeter ||
											(basket.mode == "delivery" &&
												basketTotal -
													(basket.mode == "delivery"
														? restaurant.deliveryFees
														: 0) <
													parseFloat(restaurant.minAmountDelivery))
										}
									>
										{validateBasket ? (
											<i className="fas fa-circle-notch fa-spin"></i>
										) : (
											"PAYER"
										)}
									</button>
									<p className="text-center mt-2">
										En confirmant la commande, vous acceptez les{" "}
										<span className="font-weight-bold">
											Conditions Générales d'Utilisation
										</span>
									</p>
								</>
							)}

							{basket.mode == "delivery" &&
								basketTotal - restaurant.deliveryFees <
									parseFloat(restaurant.minAmountDelivery) && (
									<p className="text-center mt-3 text-danger">
										Minimum de livraison de {restaurant.minAmountDelivery}€ non
										atteint
									</p>
								)}
							{/* Order Details End */}
						</div>
					</div>
				</form>
			</div>
			{showAlert == true && (
				<Modal
					show={showAlert}
					id="alertModeModal"
					aria-labelledby="contained-modal-title-vcenter"
					size="lg"
					centered
				>
					<AlertBasketUpdate
						mode={newMode}
						onValidate={() => {
							selectMode(newMode, true);
							setShowAlert(false);
						}}
						onHide={() => {
							setShowAlert(false);
						}}
					/>
				</Modal>
			)}
			<Modal
				show={refreshingCart}
				id="refreshCartModal"
				aria-labelledby="contained-modal-title-vcenter"
				size="sm"
				centered
			>
				<Modal.Body className="text-center" style={{ padding: "10px 0" }}>
					<h5>Mise à jour du panier</h5>
					<div className="fa-3x">
						<i className="fas fa-circle-notch fa-spin"></i>
					</div>
				</Modal.Body>
			</Modal>
		</section>
	);
};

export default Content;
